/// <reference path="DOMAttached.js" />

class FeatureLevelSelector extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.selector = null;
		this.triggeringControl = null;
		this.triggeringControlEventHandle = null;
		this.previousValue = null;
		this.selector = document.getElementById(el).querySelector(".featureLevelSelector");
		this.selector.addEventListener("change", this.onValueChange.bind(this));
		this.previousValue = this.selector.value;

		if (this.options.warningTriggeringControl !== undefined) {
			this.triggeringControl = document.getElementById(this.options.warningTriggeringControl);
			this.triggeringControlEventHandle = this.triggeringControl.addEventListener("click", this.onTriggeringControlClicked.bind(this));
		}
	}

	onValueChange(event) {
		if (this.selector.value != this.options.fullSocialEnumValue) {
			this.previousValue = this.selector.value;
		}
	}

	onTriggeringControlClicked(event) {
		if (this.selector.value == this.options.fullSocialEnumValue) {
			event.preventDefault();
			event.stopPropagation();
			confirmAI(this.options.warningTR, this.onConfirm.bind(this), this.onCancel.bind(this), true, true);
		}
	}

	onConfirm() {
		// in some browsers, simulating a click on a link does not work,
		// so instead we follow the link manually
		var link = document.getElementById(this.triggeringControl).querySelector('a');
		if (link) {
			window.location.href = document.getElementById(link).getAttribute("href");
		} else {
			this.triggeringControlEventHandle.preventDefault();
			this.triggeringControlEventHandle.stopPropagation();
			this.triggeringControl.simulate("click");
		}
	}

	onCancel() {
		this.selector.value = this.previousValue;
	}
}
